import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { leaderboardKeys } from '../leaderboard.keys';
import { getSprints } from '../leaderboard.service';
export function useSprints({ enabled = true, ...options } = {}) {
    const subdomain = getSubdomain();
    return useQuery({
        queryKey: leaderboardKeys.sprints(subdomain),
        queryFn: async () => getSprints(subdomain),
        enabled: !!subdomain && subdomain !== 'root' && enabled,
        staleTime: 5 * 60 * 1000,
        gcTime: 15 * 60 * 1000,
        retry: 1,
        ...options,
    });
}
